import Box from "@mui/material/Box";
import { FC } from "react";
import { ThreeCircles } from "react-loader-spinner";
import { CustomLoaderProps } from "../../../portal/src/app/interfaceTypes";
import palette from "../theme/palette";
import { flexCenter } from "../theme/styleConstants";
const {
  primary: { main },
} = palette;

export const CustomLoader: FC<CustomLoaderProps> = ({ height }) => (
  <Box height={height} sx={flexCenter} width="100%">
    <ThreeCircles height={50} width={50} color={main} />
  </Box>
);
